<div id="selection-popup" class="warning-popup">
  <h2 class="m-b-5" mat-dialog-title>Aviso</h2>
  <div mat-dialog-content id="leave-popup-fields">
    <div>
      <form [formGroup]="EmployeeWarningForm">
        <mat-form-field>
          <textarea matInput rows="7" placeholder="Aviso" formControlName="WarningText"></textarea>
          <mat-error *ngIf="EmployeeWarningForm.get('WarningText') && EmployeeWarningForm.get('WarningText').invalid">
            <span *ngIf="EmployeeWarningForm.get('WarningText').errors.required"
              class="validation-span">Obligatorio</span>
          </mat-error>
        </mat-form-field>
      </form>
    </div>
    <div class="text-a-r p-t-5">
      <button mat-raised-button color="accent" class="m-r-15" (click)="SaveWarningText()">Consultar</button>
      <button mat-raised-button color="warn" (click)="Close()">Cancelar</button>
    </div>
  </div>
</div>